import { compose } from 'recompose'
import { get } from 'common/utils/object'

export function pipe(...funcs) {
  return compose(...funcs.reverse())
}

export function transform(transformMap) {
  return values => {
    let dest = { ...values }

    for (let key in transformMap) {
      const funcOrObject = transformMap[key]

      if (typeof funcOrObject === 'function') {
        dest[key] = funcOrObject(dest[key])
      } else if (Array.isArray(funcOrObject)) {
        dest[key] = dest[key].map(funcOrObject[0])
      } else {
        dest[key] = transform(funcOrObject)(dest[key])
      }
    }

    return dest
  }
}

export function all(...funcs) {
  return values => funcs.every(func => func(values))
}

export function when(condition, func) {
  return values => (condition(values) ? func(values) : values)
}

export function oneOfOrFallback(list, defaultValue) {
  return value => (list.includes(value) ? value : defaultValue)
}

export function has(block) {
  return values => {
    return Boolean(get(block, values))
  }
}

export function doesntHave(block) {
  return values => {
    return !has(block)(values)
  }
}

export function pageIs(page) {
  return values => values.page === page
}

export function fallback(fallbackValue) {
  return value => value || fallbackValue
}
